import { Outlet, Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Home from "./components/pages/Home";
import About from "./components/pages/About";
import Contact from "./components/pages/Contact";
import Location from "./components/pages/Location";
import NSAGFE from "./components/pages/NSAGFE";

// import Footer from "./components/Footer";
function App() {
  const therapist = require("./data.json");
  return (
    <div className="App">
      <Navbar />
      <Outlet />
      <Routes>
        <Route path="/" element={<Home therapist={therapist} />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact therapist={therapist} />} />
        <Route path="/location" element={<Location />} />
        <Route path="/nsa" element={<NSAGFE />} />
        {/* <Route
          path="/dt/:id"
          element={<DisplayTherapist therapist={therapist} />}
        /> */}
      </Routes>
      {/* <Footer /> */}
    </div>
  );
}

export default App;
